// HeroModel.jsx
import React from 'react';
import styled from 'styled-components';
import logo3D from '../images/logos/3DLogo.png'; // Import the image

const CanvasContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background: transparent;
  display: flex;
  justify-content: flex-end; /* Align content to the right */
  align-items: center;
  padding-right: 20px; /* Add some padding */
`;

function HeroModel() {
  return (
    <CanvasContainer>
      <img src={logo3D} alt="3D Logo" style={{ width: '300px', height: 'auto' }} />
    </CanvasContainer>
  );
}

export default HeroModel;
